import React from 'react';
import PropTypes from 'prop-types';
import { useDashboardPath } from '../useDashboardPath';
import { Action } from './Action';
import { Plan } from './Plan';
import { Messages } from './Messages';

export const ClientNavFoundationalOnly = ({ onClick }) => {
  const { dashboardPath, dashboardSelectedIf } = useDashboardPath();
  // BE CAREFUL ADJUSTING THIS FILE!
  // EVEN THE SLIGHTEST ADJUSTMENT CAN CAUSE THE UI TO LOOK BAD AT THE WIDTH OF MOBILE DEVICES
  return (
    <>
      <Action value="dashboard" label="Home" icon="navDashboard" to={dashboardPath} selectedIf={dashboardSelectedIf} onClick={onClick} />
      <Plan onClick={onClick} />
      <Messages onClick={onClick} />
    </>
  );
};

ClientNavFoundationalOnly.defaultProps = {
  onClick: undefined,
};
ClientNavFoundationalOnly.propTypes = {
  onClick: PropTypes.func,
};
